(ns dre.components.platform-switcher.views
  (:require
   [clojure.string :as str]
   [dre.app.events :as app-events]
   [dre.config :as config]
   [dre.components.dropdown :refer [dropdown dropdown-list]]
   [dre.components.icon :refer [icon]]
   [dre.components.platform-switcher.db :as platforms]
   [dre.pages.frontpage.events :as frontpage]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))


(def current-platform :docsearch)  ; TODO: Implement current platform detection


(defn split-label
  [label]
  (let [[one two] (str/split label #"\s" 2)]
    [:<>
     [:span.first-word one]
     "\u00A0"
     [:span.second-word two]]))


(defn platform-switcher
  [user]
  (let [db @(rf/subscribe [::app-events/db])
        platforms-config (config/->platforms db)]
    [:ul
     {:class [:platform-switcher :hidden-lg-down]}
     (for [{:keys [id label url enabled?]} (platforms/registry platforms-config user)]
       ^{:key id}
       [:li
        {:class (bem/be :platform-switcher :item)}
        (if enabled?
          [:a
           {:href url
            :on-click (when (= id :docsearch) #(rf/dispatch [::frontpage/clear-state]))
            :class (bem/bem :platform-switcher :label [:enabled (when (= id current-platform) :current)])}
           (split-label label)]
          [:span
           {:class (bem/bem :platform-switcher :label :disabled)}
           (split-label label)
           [icon :common :lock]])])]))


(defn platform-dropdown
  [user]
  (let [db @(rf/subscribe [::app-events/db])
        platforms-config (config/->platforms db)]
    [:div
     {:class [:platform-dropdown :hidden-lg-up]}
     [dropdown
      {:anchor
       [:button.button
        [:span
         {:class (bem/bem :platform-dropdown :label :current)}
         (split-label (:label (get (platforms/index platforms-config user) current-platform)))]]

       :content
       [dropdown-list
        (for [{:keys [id label url enabled?]} (platforms/registry platforms-config user)
              :when (not= id current-platform)]
          ^{:key id}
          (if enabled?
            [:a
             {:href url
              :class (bem/bem :platform-dropdown :label :enabled)}
             label]
            [:span
             {:class (bem/bem :platform-dropdown :label :disabled)}
             label
             [icon :common :lock]]))]}]]))
